module.exports = __webpack_public_path__ + "img/5.384925d8.png";